import React, { createContext, useContext, useState } from 'react';
import { authApi } from '../api/authApi';
import { isApiConfigured } from '../api/axiosClient';
import  apiClient  from '../api/axiosClient';
import { recordLogin, recordImpersonation } from '../utils/loginTracker'; 

import { stopSignalR } from '../../src/services/signalrService';

import { NotificationContext } from "../contexts/NotificationContext";




/* ── Mock fallback (used when VITE_API_BASE_URL is not set) ─────────── */
const DEMO_USER = {
    id: 1,
    username: 'demo',
    firstName: 'Dr. Amara',
    lastName: 'Singh',
    email: 'amara.singh@healthcare.com',
    phone: '(512) 555-0147',
    organizationName: 'Austin Family Medical Group',
    npi: '1234567890',
    taxId: '74-6000203',
    address: '1111 E. Cesar Chavez',
    city: 'Austin',
    state: 'TX',
    zip: '78702',
    role: 'Super Admin',
};

const DEMO_CREDENTIALS = { username: 'demo', password: 'demo123' };
const DEMO_MFA_CODE = '123456';

/* ── Context ────────────────────────────────────────────────────────── */
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    //const { refreshNotifications } = useContext(NotificationContext);

    const [user, setUser] = useState(() => {
        const saved = localStorage.getItem('sendero_provider_user');
        return saved ? JSON.parse(saved) : null;
    });
    const [mfaPending, setMfaPending] = useState(false);
    const [mfaToken, setMfaToken] = useState(null);
    const [otpSecretKey, SetOtpSecretKey] = useState(null);
    const [otpChannel, SetOtpChannel] = useState("email");
    const [mfaEmail, setMfaEmail] = useState('');

    // Impersonation state
    const [originalUser, setOriginalUser] = useState(() => {
        const saved = localStorage.getItem('sendero_original_user');
        return saved ? JSON.parse(saved) : null;
    });
    const isImpersonating = !!originalUser;

    // Email-MFA preference (settings-controlled; persisted to localStorage so
    // the mock login flow can honour it across reloads). Defaults to ON.
    const [mfaEmailEnabled, setMfaEmailEnabledState] = useState(() => {
        const saved = localStorage.getItem('sendero_mfa_email_enabled');
        return saved === null ? true : saved === 'true';
    });

    const setMfaEmailEnabled = (value) => {
        localStorage.setItem('sendero_mfa_email_enabled', String(!!value));
        setMfaEmailEnabledState(!!value);
    };

    const login = async (username, password, turnstileToken = null) => {
        if (isApiConfigured()) {
            try {
                const response = await authApi.login(username, password, turnstileToken); 
                         

                if (!response.data.Success)
                {                    
                    await recordLogin(username, 'failed', 'failed-login', { username });                    
                    //return false;
                    return response
                }

                
                // If API returns MFA required
                if (response.data.TwoFactorRequired)
                { 
                   
                    setMfaPending(true);
                    setMfaToken(response?.data?.otpsecretkey);
                    setMfaEmail(response?.data?.UserEmail || '');
                   await recordLogin( username, 'mfa_required',"MFA", { username }).catch(() => { });

                    //sent 6 digits of code  to user email
                    const res = await authApi.sendMfaCode(response.data.otpsecretkey, otpChannel);
                    //const res = await apiClient.post('/Provider/api/auth/providertwofactorsigninmethod', {

                    //    "twoFaSessionId": response.data.otpsecretkey,
                    //    "otpChannel": "email"
                    //});
                    //reasign otpsecretkey from response
                    SetOtpSecretKey(res?.data?.otpsecretkey);                  

                    //   return 'mfa_required';

                    return response;
                }

                const token = response.data.Data.AccessToken;
                
                const refreshToken = response.data.Data.RefreshToken;
                const userData = {
                    userId: response.data.Data.UserId,
                    userName: response.data.Data.UserName,
                    email: response.data.Data.Email,
                    taxId: response.data.Data.TaxID,
                    userId: response.data.Data.UserId,
                    parentUserId: response.data.Data.ParentUserId,
                    firstName: response.data.Data.FirstName,
                    lastName: response.data.Data.LastName,
                    userRole: response.data.Data.UserRole,
                    userPermissions: response?.data?.Data?.UserPermissions ? JSON.parse(response?.data?.Data?.UserPermissions) : null
                    //orgPhone: response.data.Data.OrgPhoneNo              
                };
                
                

                // Direct login (no MFA)
             //   const { token, refreshToken, user: userData } = data;
                localStorage.setItem('sendero_token', token);
                if (refreshToken) localStorage.setItem('sendero_refresh_token', refreshToken);
                localStorage.setItem('sendero_provider_user', JSON.stringify(userData));
                setUser(userData);
                await recordLogin(username, 'success',"success-login", { username }).catch(() => { });

                
              //  return true;
                return response;
            }
            catch(err)
            {
                
                
                await recordLogin(username, 'failed', 'failed-login', { username });
                
                return false;
            }
        }

        // Fallback: mock auth with MFA simulation
        if (username === DEMO_CREDENTIALS.username && password === DEMO_CREDENTIALS.password) {
            // Honour user's settings-level MFA toggle. If the user turned Email MFA
            // off in Settings, skip the MFA step and log in directly.
            if (!mfaEmailEnabled) {
                setUser(DEMO_USER);
                localStorage.setItem('sendero_provider_user', JSON.stringify(DEMO_USER));
                recordLogin(DEMO_USER.id, 'success', { username }).catch(() => { });
                return true;
            }
            setMfaPending(true);
            setMfaToken('mock-mfa-token');
            SetOtpSecretKey('mock-mfa-token');
            setMfaEmail(DEMO_USER.email);
            recordLogin(DEMO_USER.id, 'mfa_required', { username }).catch(() => { });
            return 'mfa_required';
        }
        recordLogin('failed-login', 'failed', { username }).catch(() => { });
        return false;
    };

    const verifyMfa = async (code) => {
        if (isApiConfigured()) {
            try {
                const response = await authApi.verifyMfa(otpSecretKey, code);

                
                if (!response?.data?.Success) {                    
                    //recordLogin('failed-login', 'mfa_failed').catch(() => { });
                    await recordLogin(user.userName, 'mfa_failed', 'failed-mfa-login').catch(() => { });
                    return false;
                }
                

                const token = response.data.Data.AccessToken;
                const refreshToken = response.data.Data.RefreshToken;
                const userData = {
                    userId: response.data.Data.UserId,
                    userName: response.data.Data.UserName,
                    email: response.data.Data.Email,
                    taxId: response.data.Data.TaxID,
                    userId: response.data.Data.UserId,
                    parentUserId: response.data.Data.ParentUserId,
                    firstName: response.data.Data.FirstName,
                    lastName: response.data.Data.LastName,
                    userRole: response.data.Data.UserRole,
                    userPermissions: response.data.Data.UserPermissions ? JSON.parse(response.data.Data.UserPermissions) : null
                    //orgPhone: response.data.Data.OrgPhoneNo              
                };

                //const { token, refreshToken, user: userData } = response.data;
                localStorage.setItem('sendero_token', token);
                if (refreshToken) localStorage.setItem('sendero_refresh_token', refreshToken);
                localStorage.setItem('sendero_provider_user', JSON.stringify(userData));
                setUser(userData);
                setMfaPending(false);
                setMfaToken(null);
                SetOtpSecretKey(null);
                setMfaEmail('');
                
                await recordLogin(mfaEmail, 'success', "success-mfa-login").catch(() => { });
                return true;
            } catch
            {
                
                
                await recordLogin(mfaEmail, 'mfa_failed', 'failed-mfa-login').catch(() => { });
                return false;
            }
        }

        // Mock: accept code "123456"
        if (code === DEMO_MFA_CODE) {
            setUser(DEMO_USER);
            localStorage.setItem('sendero_provider_user', JSON.stringify(DEMO_USER));
            setMfaPending(false);
            setMfaToken(null);
            SetOtpSecretKey(null);
            setMfaEmail('');
            recordLogin(DEMO_USER.id, 'success', { mfa: true }).catch(() => { });
            return true;
        }
        recordLogin(DEMO_USER.id, 'mfa_failed').catch(() => { });
        return false;
    };

    const resendMfa = async () => {
        
        if (isApiConfigured()) {
            try {
                
                var res = await authApi.resendMfa(mfaToken, otpChannel);                
                SetOtpSecretKey(res?.data?.otpsecretkey); 
                return true;
            } catch {
                return false;
            }
        }
        return true; // Mock always succeeds
    };

    const cancelMfa = () => {
        setMfaPending(false);
        setMfaToken(null);
        SetOtpSecretKey(null);
        setMfaEmail('');
    };

    /* ── Impersonation ──────────────────────────────────────────── */
    const impersonate = async (targetUser) => {
        // Guard rails       
        
        if (user?.userRole !== 'Super Admin') return false;

        
        //if (targetUser.id === user.id) return false;
        if (targetUser.id === user.userId) return false;

        
        if (targetUser.role === 'Super Admin') return false;

        

        // Save current (Super Admin) as original
        const currentToken = localStorage.getItem('sendero_token') || '';
        const currentRefreshToken = localStorage.getItem('sendero_refresh_token') || '';
        localStorage.setItem('sendero_original_user', JSON.stringify(user));
        localStorage.setItem('sendero_original_token', currentToken);
        localStorage.setItem('sendero_original_refresh_token', currentRefreshToken);
        setOriginalUser(user);

        if (isApiConfigured()) {

            try {
                
                const res = await authApi.impersonate(targetUser.id);

                const data = res?.data;

                if (data?.Success)
                {
                    
                    //const { token, targetUser: impersonatedUser } = data?.Data;

                    //stop signalR of original user
                    await stopSignalR();
                    //alert(user.userId);
                    await recordImpersonation(user.userId, targetUser.id, 'success', 'start-impersonate', { userName: targetUser.userName });

                    const userData = {
                        userId: targetUser.id,
                        userName: targetUser.userName,
                        email: targetUser.email,
                        taxId: targetUser.taxId,
                        parentUserId: targetUser.parentUserId,
                        firstName: targetUser.firstName,
                        lastName: targetUser.lastName,
                        userRole: targetUser.role,
                        userPermissions: targetUser.permissions 

                    };

                    //console.log("------------Impersonated User-----------------");
                    //console.log("IMPERSONATED USER DATA :"+JSON.stringify(userData));
                    //console.log("----------------------------------------------");
                    
                    localStorage.setItem('sendero_token', data?.Data?.access_token);                    
                    localStorage.setItem('sendero_refresh_token', data?.Data?.refresh_token);
                    localStorage.setItem('sendero_provider_user', JSON.stringify(userData));

                    setUser(userData);

                    
                    
                    
                    return true;
                }
                else {
                    await recordImpersonation(user.userId, targetUser.id, 'failed', 'failed-impersonate', { userName: targetUser.userName });
                    return false;
                }

                
            } catch {
                // Rollback
                await recordImpersonation(user.userId, targetUser.id, 'failed', 'failed-impersonate', { userName: targetUser.userName });
                localStorage.removeItem('sendero_original_user');
                localStorage.removeItem('sendero_original_token');
                localStorage.removeItem('sendero_original_refresh_token');
                setOriginalUser(null);
                return false;
            }
        }

        // Mock: swap user locally
        const impersonatedMock = {
            ...targetUser,
            firstName: targetUser.firstName || 'User',
            lastName: targetUser.lastName || '',
            email: targetUser.email || '',
        };
        localStorage.setItem('sendero_provider_user', JSON.stringify(impersonatedMock));
        setUser(impersonatedMock);
        return true;
    };

    const endImpersonation = async () => {
        
        if (!originalUser) return false;

        if (isApiConfigured()) {
            try {
                //stop signalR of impersonate user
                await stopSignalR();

                const response = await authApi.endImpersonation();


                
            } catch {
                // Fall through to local restore from originalUser
            }
        }

       
        await recordImpersonation(originalUser.userId, user.userId, 'logout', 'end-impersonate', { userName: user.userName });

        // Restore from saved original
        const savedToken = localStorage.getItem('sendero_original_token');
        const savedRefreshToken = localStorage.getItem('sendero_original_refresh_token');
        if (savedToken) localStorage.setItem('sendero_token', savedToken);
        if (savedRefreshToken) localStorage.setItem('sendero_refresh_token', savedRefreshToken);
        localStorage.setItem('sendero_provider_user', JSON.stringify(originalUser));
        setUser(originalUser);

        // Clear impersonation state
        localStorage.removeItem('sendero_original_user');
        localStorage.removeItem('sendero_original_token');
        localStorage.removeItem('sendero_original_refresh_token');
        setOriginalUser(null);
        return true;
    };

    const logout = async () => {
        if (isApiConfigured()) authApi.logout().catch(() => { });
        // Record before clearing state so we still know who logged out.
        if (user?.userId) await recordLogin(user.userName, 'logout',"logout").catch(() => { });
        setUser(null);
        setOriginalUser(null);
        setMfaPending(false);
        setMfaToken(null);
        SetOtpSecretKey(null);
        setMfaEmail('');
        await stopSignalR();
        localStorage.removeItem('sendero_provider_user');
        localStorage.removeItem('sendero_token');
        localStorage.removeItem('sendero_refresh_token');
        localStorage.removeItem('sendero_original_user');
        localStorage.removeItem('sendero_original_token');
        localStorage.removeItem('sendero_original_refresh_token');
    };


    const signalRLogout = async () => {
        
        // Record before clearing state so we still know who logged out.
        if (user?.userId) await recordLogin(user.userName, 'logout', "logout").catch(() => { });
        setUser(null);
        setOriginalUser(null);
        setMfaPending(false);
        setMfaToken(null);
        SetOtpSecretKey(null);
        setMfaEmail('');
        await stopSignalR();
        localStorage.removeItem('sendero_provider_user');
        localStorage.removeItem('sendero_token');
        localStorage.removeItem('sendero_refresh_token');
        localStorage.removeItem('sendero_original_user');
        localStorage.removeItem('sendero_original_token');
        localStorage.removeItem('sendero_original_refresh_token');
    };

    const refreshAccessToken = async (refrToken, isImpersonatingUser) => {
        //alert("refrToken : " + refrToken + "isImpersonatingUser : " + isImpersonatingUser);
        if (isApiConfigured()) {
            try {
                
                const response = await authApi.refreshToken(refrToken, isImpersonatingUser);                
                //console.log("HIT RF2");  
                if (!response.data.Success)
                {
                    //console.log("-------------------------------------");    
                    //console.log("Faild to get new refresh access token : "+JSON.stringify(response));
                    //console.log("-------------------------------------");    
                    return false;
                }               


                const token = response?.data?.Data?.AccessToken;               
                
                
                const refreshToken = response?.data?.Data?.RefreshToken;
                
                const userData = {
                    userId: response?.data?.Data?.UserId,
                    userName: response?.data?.Data?.UserName,
                    email: response?.data?.Data?.Email,
                    taxId: response?.data?.Data?.TaxID,
                    userId: response?.data?.Data?.UserId,
                    parentUserId: response?.data?.Data?.ParentUserId,
                    firstName: response?.data?.Data?.FirstName,
                    lastName: response?.data?.Data?.LastName,
                    userRole: response?.data?.Data?.UserRole,
                    userPermissions: response?.data?.Data?.UserPermissions ? JSON.parse(response?.data?.Data?.UserPermissions) : null
                    
                    //orgPhone: response.data.Data.OrgPhoneNo              
                };                

                
                localStorage.setItem('sendero_token', token);
                
                if (refreshToken) localStorage.setItem('sendero_refresh_token', refreshToken);

                
                localStorage.setItem('sendero_provider_user', JSON.stringify(userData));
                
                setUser(userData);
                
                setMfaPending(false);
                
                setMfaToken(null);
                
                SetOtpSecretKey(null);
                
                setMfaEmail('');                
              //  await recordLogin(username, 'success', "success-login", { username }).catch(() => { });         

                
              
                return true;
            } catch {

                
             //   await recordLogin(username, 'failed', 'failed-login', { username });
                return false;
            }
        }

        
        return false;
    };

    const getToken = () => localStorage.getItem('sendero_token');

    return (
        <AuthContext.Provider value={{
            user, login, logout, getToken, isAuthenticated: !!user,
            mfaPending, mfaEmail, verifyMfa, resendMfa, cancelMfa,
            mfaEmailEnabled, setMfaEmailEnabled,
            isImpersonating, originalUser, impersonate, endImpersonation, refreshAccessToken, signalRLogout
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
};
